/**
 * Enum para representar os tipos de roles (papéis) de usuários no sistema
 * Cada valor numérico corresponde ao role_id no banco de dados
 */
export enum UserRoleEnum {
    /** Sócio Diretor - Gestão */
    SOCIO_DIRETOR_GESTAO = 1,

    /** Administrador de Sistemas */
    ADMINISTRADOR_SISTEMAS = 2,

    /** Sócio Diretor - Líder Escritório */
    SOCIO_DIRETOR_LIDER_ESCRITORIO = 3,

    /** Sócio Operador Renda Variável */
    SOCIO_OPERADOR_RENDA_VARIAVEL = 4,

    /** Sócio Assessor */
    SOCIO_ASSESSOR = 5,

    /** Sócio Diretor - Especialista de Renda VARIÁVEL */
    SOCIO_DIRETOR_ESPECIALISTA_RENDA_VARIAVEL = 7,

    /** Sócio Diretor - Especialista Fundos e Previdência */
    SOCIO_DIRETOR_ESPECIALISTA_FUNDOS_PREVIDENCIA = 8,

    /** Sócio Diretor - Especialista de Renda FIXA e COE */
    SOCIO_DIRETOR_ESPECIALISTA_RENDA_FIXA_COE = 9,

    /** Sócio Diretor - Administrativo */
    SOCIO_DIRETOR_ADMINISTRATIVO = 10,

    /** Sócio Assessor - Administrativo */
    SOCIO_ASSESSOR_ADMINISTRATIVO = 11,

    /** Sócio Diretor - Líder Regional */
    SOCIO_DIRETOR_LIDER_REGIONAL = 13,

    /** Especialista Previdência */
    ESPECIALISTA_PREVIDENCIA = 14,

    /** Especialista Gestão Patrimonial */
    ESPECIALISTA_GESTAO_PATRIMONIAL = 16,

    /** Especialista Crédito CONSÓRCIO */
    ESPECIALISTA_CREDITO_CONSORCIO = 17,

    /** Sócio Assessor Restrito */
    SOCIO_ASSESSOR_RESTRITO = 18,

    /** Migração */
    MIGRACAO = 19,

    /** Assistente de Prospecção */
    ASSISTENTE_PROSPECCAO = 20,

    /** PROSPERIDADE */
    PROSPERIDADE = 54,

    /** Gestor PJ2 */
    GESTOR_PJ2 = 55,

    /** Gestor da célula prospecção */
    GESTOR_CELULA_PROSPECCAO = 56,

    /** Sócio ADM - Diretoria */
    SOCIO_ADM_DIRETORIA = 58,

    /** Especialista Plano de Saúde */
    ESPECIALISTA_PLANO_SAUDE = 59,

    /** Especialista Franquia */
    ESPECIALISTA_FRANQUIA = 60,

    /** Especialista Banking */
    ESPECIALISTA_BANKING = 61,
}
